import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import last from 'lodash/last'

import withAuthorization from '../higherOrder/withAuthorization'
import { QuestionWrapper, QuestionText, QuestionTextSpan, OptionsWrapper } from '../StyledComponents/IntroQuestions/Question'
import Option from '../IntroQuestions/Option'
import { SETTINGS, INTRO_QUESTIONS } from '../../constants/routes'
import { setIntroQuestionsState, saveUserSettings } from '../../actions'
import { settingsFromQuestions } from '../utilities/helpers'

class IntroQuestionsSuccessPage extends Component {
    constructor(props) {
        super(props)

        this.onViewSettingsClicked = this.onViewSettingsClicked.bind(this)
    }

    componentDidMount() {
        const {
            sessionState, saveSettings, questions, setIntroState, history,
        } = this.props

        if (!last(questions).answer) {
            history.push(INTRO_QUESTIONS)
        }

        if (!!sessionState
            && !!sessionState.idToken
            && !!sessionState.authUser) {
            const { token } = sessionState.idToken
            setIntroState(sessionState.authUser.uid, token, 'done')

            saveSettings(sessionState.authUser.uid, token, settingsFromQuestions(questions))
        }
    }

    onViewSettingsClicked() {
        this.props.history.push(SETTINGS)
    }

    render() {
        const text = 'Danke! Mit Hilfe deiner Antworten haben wir ein paar Standardeinstellungen für dich ermittelt.'
        const option = {
            label: 'Einstellungen anzeigen',
        }

        return (
            <QuestionWrapper>
                <QuestionText>
                    <QuestionTextSpan>{text}</QuestionTextSpan>
                </QuestionText>
                <OptionsWrapper>
                    <Option
                        data={option}
                        fullWidth
                        onOptionClicked={this.onViewSettingsClicked}
                    />
                </OptionsWrapper>
            </QuestionWrapper>
        )
    }
}

const authCondition = authUser => !!authUser

const mapStateToProps = state => ({
    questions: state.introQuestions.questions,
    sessionState: state.sessionState,
})

export default compose(
    withAuthorization(authCondition),
    withRouter,
    connect(mapStateToProps, {
        setIntroState: setIntroQuestionsState,
        saveSettings: saveUserSettings,
    })
)(IntroQuestionsSuccessPage)



// WEBPACK FOOTER //
// ./src/components/pages/IntroQuestionsSuccess.js